import React from "react";
import Image from "./Image";

export default function Logo({ ...p }) {
  return <Image i="logo" width="10vh" />;
}
